
/* styles */
require("!!vue-style-loader!css-loader?sourceMap!../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-72a5ae45\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./notetask.vue.html")

var Component = require("!../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!awesome-typescript-loader?silent=true!./notetask.ts"),
  /* template */
  require("!!../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-72a5ae45\"}!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./notetask.vue.html"),
  /* scopeId */
  "data-v-72a5ae45",
  /* cssModules */
  null
)
Component.options.__file = "C:\\_Team\\_Net\\Web\\AuxiliumSolution\\Auxilium.APP\\ClientApp\\src\\portalhome\\docketing\\pages\\hearingdetails\\notetask\\notetask.vue.html"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] notetask.vue.html: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-72a5ae45", Component.options)
  } else {
    hotAPI.reload("data-v-72a5ae45", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./ClientApp/src/portalhome/docketing/pages/hearingdetails/notetask/notetask.vue.html
// module id = 576
// module chunks = 0